module.exports = __webpack_public_path__ + "assets_app/img/key_2.316d85b8.svg";